import React, { useEffect, memo } from 'react';
import { useSensorData } from '../../contexts/SensorDataContext';

interface CalibrationDataBridgeProps {
  userWeight: number;
  addedWeights: number;
  children: React.ReactNode;
}

const CalibrationDataBridge: React.FC<CalibrationDataBridgeProps> = memo(({ 
  userWeight, 
  addedWeights, 
  children 
}) => {
  const { setCalibrationDataFromExternal, resetCalibrationData } = useSensorData();

  useEffect(() => {
    if (userWeight > 0) {
      setCalibrationDataFromExternal(userWeight, addedWeights);
    }
  }, [userWeight, addedWeights, setCalibrationDataFromExternal]);

  return <>{children}</>;
});

export default CalibrationDataBridge;
